import { render, staticRenderFns } from "./menuFooter.vue?vue&type=template&id=5d51a141&lang=pug"
import script from "./menuFooter.vue?vue&type=script&lang=coffee"
export * from "./menuFooter.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports